import React, { useState, useEffect, useMemo } from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import {
  Box, CircularProgress, Typography, TextField, IconButton, Button, useTheme, Grid2, Tooltip,
  Stack,
  Breadcrumbs,
  Link
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { RxCross2 } from "react-icons/rx";
import { useParams } from 'react-router-dom';
import { useEditQuantityListQuery } from 'store/slices/apis/keyDPRPMSlice';
import ConfirmChangesPopup from './DprPopUp';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaPlus, } from "react-icons/fa6";
import AddNewDpr from './AddNewDpr';
import TableComponent from 'components/grid';
import moment from 'moment';
import ConfirmationDuantityDPR from './ConfirmationDuantityDPR';
import {ReactComponent as LeftArrowicon} from "assets/PwC_Funct_Icons_ArrowLeft_Outline_Black_RGB.svg"
import {ReactComponent as AddNewIcon} from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"


type Person = {
  id: number;
  activityName: string;
  unit: string;
  boq: string;
  estimated: string;
  planned: string;
  executed: string;
  overall: string;
  date: string;
  ptyqty: string;
  actual: string;
  percentage: string;
};


const columns = [
  {
    name: 'WBS Level',
    field: 'name',
    renderer(params) {
      return (
        <Breadcrumbs separator=">" aria-label="breadcrumb" sx={{ fontSize: '14px' }}>
          {params?.wbsLevel?.length > 0 &&
            params.wbsLevel.map((item, index) => {
              const isLast = index === params.wbsLevel.length - 1;
              return isLast ? (
                <Typography key={index} color="text.primary" sx={{ fontSize: '14px' }}>
                  {item?.name}
                </Typography>
              ) : (
                <Link underline="hover" key={index} color="inherit">
                  {item?.name}
                </Link>
              );
            })}
        </Breadcrumbs>
      )
    }
  },
  {
    name: 'Activity Name',
    field: 'name',
  },
  {
    name: 'BOQ',
    field: 'boq',
  },
  {
    name: 'Planned Qty Till Date',
    field: 'planned_Qty_Till_Date',
  },
  {
    name: 'Executed Qty Till Date',
    field: 'executed_Qty_Till_Date',
  },
  {
    name: 'Day',
    field: 'day',
    renderer(params) {
      return (
        <Stack direction="row" spacing={1}>
          {moment(params?.day).format("DD/MM/YYYY")
          }
        </Stack>
      );
    }
  },
  {
    name: 'Planned Quantity For Day',
    field: 'planned_Qty_For_Day'
  },
  {
    name: 'Actual Qty',
    field: 'actualQty',
  },
  {
    name: 'Actual Manpower',
    field: 'actualManpower',
  },
]

export default function CreateNewDpr() {
  const [tableData, setTableData] = useState([]);
  const [activitiesData, setActivitiesData] = useState([]);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const { projectId } = useParams();
  const [editedRows, setEditedRows] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const theme = useTheme();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [showAddIssue, setShowAddIssue] = useState(false);
  const [reportingDate, setReportingDate] = useState(null);

  const { data, isLoading, error } = useEditQuantityListQuery({ projectId })
  const allData = data?.data || []

  useEffect(() => {
    const modifiedData = allData.map(row => ({
      ...row,
      actual_Qty_For_Day: '',
      percentage: ''
    }));
    setTableData(modifiedData);
  }, [allData]);


  const handleChange = (id, field, value) => {
    setTableData(prev =>
      prev.map(row => {
        if (row.id === id) {
          const updatedRow = { ...row, [field]: value };

          if (field === 'actual_Qty_For_Day') {
            const actualQty = parseFloat(value);
            const plannedQty = parseFloat(updatedRow.planned_Qty_For_Day);
            if (!isNaN(actualQty) && !isNaN(plannedQty) && plannedQty !== 0) {
              updatedRow.percentage = ((actualQty / plannedQty) * 100).toFixed(2) + '%';
            } else {
              updatedRow.percentage = '';
            }
          }

          return updatedRow;
        }
        return row;
      })
    );
  };


  const openNotification = (message, type = 'success') => {
    dispatch(openSnackbar({
      open: true,
      message,
      variant: 'alert',
      alert: {
        color: type,
      },
      close: false,
    }));

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const handleAddIssue = () => {
    setShowAddIssue(!showAddIssue);
  }


  const handleConfirmChanges = () => {

    // setShowConfirmPopup(false);
    // setEditingRowIds([]);
  };

  const toggleEdit = (id) => {
    setEditingRowIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handlebackIcon = () => {
    navigate(`/projects/${projectId}/dpr/Quantity_list`);

  }

  const handleSave = () => {
    if (reportingDate != null) {
      if (activitiesData?.length > 0) {

        const enrichedData = activitiesData?.map(item => ({
          ActivityId: item?.id,
          ActivityCode: item?.activity_Code,
          ActivityName: item?.name,
          UOM: '',
          BOQ: item?.boq,
          PlannedQtyTillDate: item?.planned_Qty_Till_Date,
          ActualQtyTillDate: item?.planned_Qty_Till_Date,
          OverallProgress: item?.overall_Progress,
          ReportedDate: reportingDate ? dayjs(reportingDate).format("YYYY-MM-DD") : '',
          PlannedQuantity: item?.planned_Qty_For_Day,
          ActualQuantity: item?.actualQty,
          PlannedManpower: item?.planned_Manpower_For_Day,
          ActualManpower: item?.actualManpower,
          Percentage: (item?.planned_Manpower_For_Day / item?.actualManpower) * 100 ?? 0,
        }));

        let postData = {
          ProjectId: projectId,
          ReportedDate: reportingDate ? dayjs(reportingDate).format("YYYY-MM-DD") : '',
          ActivityCount: enrichedData?.length,
          QuantityDprDetails: enrichedData
        }
        setEditedRows(postData);
        setShowConfirmPopup(true);
      } else {
        openNotification('At least one activity is required.', 'error')
      }
    } else {
      openNotification('Reporting date field is required.', 'error')
    }
    // const editedRows = tableData.filter(row => editingRowIds.includes(row.id));
    // console.log("Send this data to backend: ", editedRows);
    // setEditedRows(editedRows);
    // setShowConfirmPopup(true);
  };
  // const columns: MRT_ColumnDef<Person>[] = [
  //   {
  //     accessorKey: 'activity_Code',
  //     header: 'Activity Name',
  //     size: 100,
  //     Cell: ({ row }) => {
  //       const activity_Code = row.original.activity_Code;
  //       const name = row.original.name;
  //       return `${activity_Code} / ${name}`;
  //     },
  //   },
  //   { accessorKey: 'unit', header: 'Unit', size: 60 },
  //   { accessorKey: 'boq', header: 'BOQ', size: 60 },
  //   { accessorKey: 'planned_Qty_Till_Date', header: 'Planned Qty till date', size: 80 },
  //   { accessorKey: 'executed_Qty_Till_Date', header: 'Executed Qty till date', size: 80 },
  //   { accessorKey: 'qty', header: 'quantity', size: 80 },
  //   { accessorKey: 'estimates', header: 'Esitimates', size: 80 },
  //   { accessorKey: 'overall_Progress', header: 'Overall %', size: 60 },
  //   {
  //     accessorKey: 'day',
  //     header: 'Date',
  //     size: 110,
  //     Cell: ({ row }) => {
  //       const isEditing = editingRowIds.includes(row.original.id);
  //       return isEditing ? (
  //         <LocalizationProvider dateAdapter={AdapterDayjs}>
  //           <DatePicker
  //             format="DD/MM/YYYY"
  //             value={row.original.day ? dayjs(row.original.day) : null}
  //             onChange={(newValue) =>
  //               handleChange(
  //                 row.original.id,
  //                 'day',
  //                 newValue ? dayjs(newValue).toISOString() : ''
  //               )
  //             }
  //             slotProps={{
  //               textField: {
  //                 size: 'small',
  //                 variant: 'standard',
  //                 sx: { minWidth: '110px', },
  //               },
  //             }}
  //           />
  //         </LocalizationProvider>
  //       ) : (
  //         <span>{row.original.day ? dayjs(row.original.day).format('DD/MM/YYYY') : ''}</span>
  //       );
  //     },
  //   },
  //   {
  //     accessorKey: 'planned_Qty_For_Day',
  //     header: 'Planned Qty',
  //     size: 80,
  //   },
  //   {
  //     accessorKey: 'actualQty',
  //     header: 'Actual Qty',
  //     size: 80,
  //     Cell: ({ row }) => {
  //       const isEditing = editingRowIds.includes(row.original.id);
  //       return isEditing ? (
  //         <TextField
  //           variant="standard"
  //           value={row.original.actual_Qty_For_Day}
  //           onChange={(e) => handleChange(row.original.id, 'actual_Qty_For_Day', e.target.value)}
  //           sx={{ width: '80px' }}
  //         />
  //       ) : (
  //         <span>{row.original.actual}</span>
  //       );
  //     },
  //   },
  //   {
  //     accessorKey: 'actualManpower',
  //     header: 'Actual Manpower',
  //     size: 80,
  //   },
  //   {
  //     accessorKey: 'percentage',
  //     header: '%',
  //     size: 90,
  //     muiTableHeadCellProps: {
  //       sx: { whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'center' },
  //     },
  //     Cell: ({ row }) => {
  //       return <span>{row.original.percentage}</span>;
  //     },
  //   },
  //   {
  //     header: 'Action',
  //     size: 50,
  //     Cell: ({ row }) => {
  //       const isEditing = editingRowIds.includes(row.original.id);
  //       return isEditing ? (
  //         <IconButton onClick={() => toggleEdit(row.original.id)}>
  //           <RxCross2 />
  //         </IconButton>
  //       ) : (
  //         <IconButton onClick={() => toggleEdit(row.original.id)}>
  //           <EditIcon />
  //         </IconButton>
  //       );
  //     },
  //   },
  // ];

  const CustomCalendarIcon = (props) => (
      <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
    );



  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: '20px' }}>
        <Grid2 size={12}>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>
              <Tooltip
                placement="bottom"
                title="Back"
                arrow
                slotProps={{
                  tooltip: { sx: { fontSize: "12px" } },
                }}
              >
                <IconButton
                  aria-label="download"
                  size="small"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  {/* <IoMdArrowRoundBack style={{ height: '22px', width: '22px', color: "#252525" }} /> */}
                  <LeftArrowicon style={{ height: '22px', width: '22px', color: "#252525" , stroke: "#252525", strokeWidth: 6   }} />
                  
                </IconButton></Tooltip>

              Create New DPR
            </Typography>
          </Box>
        </Grid2>
        <Grid2 size={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: 'start', sm: 'center' },
              justifyContent: "space-between",
              flexDirection: { xs: 'column', sm: 'row' }
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{
                // flexGrow: 2,
                alignItems: { xs: "stretch", sm: "center" }, // Full width on mobile
                width: { xs: '100%', sm: 'auto' }, // Stack takes full width
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Reporting Date"
                  format="DD-MM-YYYY"
                  onChange={(newValue) => setReportingDate(newValue)}
                  slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                  slotProps={{
                    textField: {
                      variant: "filled",
                      size: 'small',
                      placeholder: "DD/MM/YYYY",
                      InputLabelProps: {
                        style: { fontSize: 16, fontWeight: 400 },
                        shrink: true,
                      },
                      // inputProps: {
                      //   style: { height: "2px" },
                      // },
                      onKeyDown: (e) => e.preventDefault(),
                      sx: {
                        // backgroundColor: "#fff",
                        input: {
                          "&::placeholder": {
                            fontSize: 16,
                            fontWeight: 400,
                          },
                        },
                        "& .MuiFormLabel-asterisk": {
                          color: "red",
                        },
                      },
                    },
                    inputLabel: { shrink: true },
                  }}
                />
              </LocalizationProvider>
              <Button
                onClick={handleAddIssue}
                size="large"
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 15px",
                  marginTop: "12px !important",
                }}
              >
                Search Activity
              </Button>
            </Stack>
            <Button
              variant="contained"
              // startIcon={<FaPlus sx={{ marginBottom: "2px" }} />}
              startIcon={<AddNewIcon style={{ height: "18px", width: "18px", fill: "#FFFFFF", stroke:"#FFFFFF", strokeWidth:4 }}  />}
              onClick={handleSave}
              sx={{
                backgroundColor: `${theme?.customSettings?.themeColor}`,
                color: "#FFF",
                padding: "5px 20px",
                fontWeight: "500",
                textTransform: "none",
                fontSize: "16px",
                marginTop: "10px",
                // marginLeft: '20px',
                border: `1px solid ${theme?.customSettings?.themeColor}`,
                '&.Mui-disabled': {
                  border: 'none'
                }
              }}
            >
              Save
            </Button>
          </Box>
        </Grid2>
        {/* <Grid2 size={12}>
          <Box sx={{ pl: "20px", mt: "60px" }}>
            <Button
              variant="contained"
              onClick={handleAddIssue}
              startIcon={<FaPlus style={{ fontSize: '14px' }} />}
              sx={{
                backgroundColor: `${theme?.customSettings?.themeColor}`,
                color: '#FFF',
                padding: '6px 20px',
                fontWeight: '500',
                textTransform: 'none',
                fontSize: '16px',
                whiteSpace: "nowrap",
              }}
            >
              Add New Dpr
            </Button>
            <Box sx={{ display: "flex", justifyContent: "end", mt: "20px" }}>
              <Box>
                <Button sx={{ border: '1px solid #25252517', p: "6px", backgroundColor: theme?.customSettings?.themeColor, color: "#fff" }}
                  onClick={handleSave}
                >
                  Save
                </Button>

              </Box>
            </Box> 
          </Box>
        </Grid2>*/}
        <Grid2 size={12} sx={{ mt: 0 }}>
          <TableComponent
            columns={columns}
            data={activitiesData}
          // isLoading={isLoading}
          />
        </Grid2>
      </Grid2>

      {/* <Box sx={{ mt: 2 }}>
          {isLoading ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error">Failed to load data.</Typography>
          ) : (
            <MaterialReactTable
              columns={columns}
              data={activitiesData}
              layoutMode="semantic" // important!
              enableColumnResizing
              columnResizeMode="onEnd"
              muiTableBodyCellProps={{
                sx: {
                  padding: '8px',
                  fontSize: '12px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  padding: '4px',
                  fontSize: '12px',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  textAlign: 'center',
                },
              }}
            />


          )}
        </Box> */}
      {showConfirmPopup &&
        <ConfirmationDuantityDPR
          open={showConfirmPopup}
          onClose={() => {
            setEditedRows(null)
            setShowConfirmPopup(false)
          }
          }
          openNotification={openNotification}
          data={editedRows}
        />
      }

      {showAddIssue &&
        <AddNewDpr cancelIssue={handleAddIssue} open={showAddIssue} manageActivities={setActivitiesData} />
      }

    </>
  );
}